<template>

    <div class="content">
        <div class="row justify-content-center">
            <div class="col-md-8">
                <RecoverPasswordForm />
            </div>
        </div>
    </div>

</template>

<script>
import RecoverPasswordForm from "@/components/form/RecoverPasswordForm";

export default {
    name: 'RecoverPasswordView',
    components: {
        RecoverPasswordForm,
    },
    computed: {
        breadcrumbs() {
            return this.$store.getters['breadcrumbs/getBreadcrumbs'];
        }
    },
    mounted() {
        this.breadcrumbs.dashboard = 'Wachtwoord aanpassen'
        this.breadcrumbs.form = null;
        this.breadcrumbs.formStep = null;

        this.$store.commit('breadcrumbs/updateBreadcrumbs', this.breadcrumbs);
    },
}
</script>
